import React, { useState, useEffect, useContext } from "react";
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import HomePage from "./pages/HomePage";
import CourseDetail from "./pages/CourseDetail";
import Assessments from "./pages/Assessments";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import Panel from "./pages/Panel";
import AdminPage from "./pages/AdminPage";
import InstructorPage from "./pages/InstructorPage";
import BlogPage from "./pages/BlogPage";
import AppointmentPage from "./pages/AppointmentPage";
import BorrowRequestPage from "./pages/BorrowRequestPage";
import Sidebar from "./components/Sidebar";
import Topbar from "./components/Topbar";
import ContactForm from "./components/ContactForm"; 
import UserProfilePage from './components/UserProfilePage';


export const ApiUrlContext = React.createContext('https://iyiliginmucitleri.com/api');


// Bu genişliğin altında kenar menüsü soldan açılan çekmeceye dönüşür
const MOBILE_BREAKPOINT = 900;

// Route koruma bileşeni
const ProtectedRoute = ({ children, requiredRole, userRole }) => {
  // Rol henüz yüklenmediyse bekle; aksi halde sayfa yenilenince admin anasayfaya atılıyordu
  if (userRole === null) {
    return <div style={{ padding: 24, color: "#888" }}>Yükleniyor...</div>;
  }
  if (requiredRole === "admin" && userRole !== "admin") {
    return <Redirect to="/" />;
  }
  if (requiredRole === "instructor" && !["instructor", "admin"].includes(userRole)) {
    return <Redirect to="/" />;
  }
  return children;
};

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(
    !!localStorage.getItem("token")
  );
  const apiUrl = useContext(ApiUrlContext);
  const [userRole, setUserRole] = useState(() => (localStorage.getItem("token") ? null : "student"));
  const [user, setUser] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(() => window.innerWidth <= MOBILE_BREAKPOINT);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= MOBILE_BREAKPOINT;
      setIsMobile(mobile);
      if (!mobile) {
        setSidebarOpen(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const fetchUserData = async () => {
      if (isAuthenticated) {
        try {
          const token = localStorage.getItem("token");
          const response = await fetch(`${apiUrl}/user/profile`, {
            headers: { Authorization: token ? `Bearer ${token}` : "" }
          });
          if (response.ok) {
            const userData = await response.json();
            setUserRole(userData.role || "student");
            setUser({
              name: userData.name || "Kullanıcı",
              email: userData.email,
              role: userData.role || "student"
            });
          } else if (response.status === 401) {
            localStorage.removeItem("token");
            setIsAuthenticated(false);
            setUser(null);
            setUserRole("student");
          } else {
            setUserRole("student");
          }
        } catch (error) {
          console.error("Kullanıcı bilgileri alınamadı:", error);
          setUserRole("student");
        }
      }
    };

    fetchUserData();
  }, [isAuthenticated, apiUrl]);

  const handleAuth = (token, userData) => {
    localStorage.setItem("token", token);
    setIsAuthenticated(true);
    if (userData) {
      setUser(userData);
      setUserRole(userData.role || "student");
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    setIsAuthenticated(false);
    setUserRole("student");
    setUser(null);
  };

  return (
    <ApiUrlContext.Provider value="https://iyiliginmucitleri.com/api">
      <Router>
        {!isAuthenticated ? (
          // GİRİŞ YAPILMAMIŞSA
          <Switch>
            <Route path="/register">
              <RegisterPage onAuth={handleAuth} />
            </Route>
            <Route path="/forgot-password">
              {React.createElement(require("./pages/ForgotPassword").default)}
            </Route>
            <Route path="/reset-password">
              {React.createElement(require("./pages/ResetPassword").default)}
            </Route>
            <Route path="/auth-success" component={require("./pages/AuthSuccess").default} />
            <Route path="/">
              <LoginPage onAuth={handleAuth} />
            </Route>
          </Switch>
        ) : (
          // GİRİŞ YAPILMIŞSA
          <div className="app-root">
            {isMobile ? (
              <>
                {/* Mobil / tablet: soldan açılan çekmece menü */}
                <div className={`sidebar-drawer ${sidebarOpen ? "open" : ""}`} aria-hidden={!sidebarOpen}>
                  <Sidebar onClose={() => setSidebarOpen(false)} isMobile />
                </div>
                {sidebarOpen && (
                  <div className="sidebar-overlay" onClick={() => setSidebarOpen(false)} />
                )}
              </>
            ) : (
              <Sidebar isMobile={false} />
            )}

            {/* Ana içerik */}
            <div className="app-main">
              <Topbar 
                onLogout={handleLogout} 
                onMenuClick={isMobile ? () => setSidebarOpen(!sidebarOpen) : undefined} 
                user={user}
              />
              <div className="main-content">
                <Switch>
                  <Route exact path="/panel" component={Panel} />
                  <Route exact path="/" render={() => <Redirect to="/panel" />} />
                  <Route exact path="/courses" component={HomePage} />
                  <Route path="/assessments" component={Assessments} />
                  <Route path="/course/:id" component={CourseDetail} />
                  <Route path="/blog/:courseId" component={BlogPage} />
                  <Route path="/contact" component={ContactForm} />
                  <Route path="/appointments" component={AppointmentPage} />
                  <Route path="/borrow-requests" component={BorrowRequestPage} />
                  
                  {/* PROFILE ROUTE'u buraya ekledik */}
                  <Route path="/profile">
                    <UserProfilePage />
                  </Route>
                  
                  <Route path="/admin">
                    <ProtectedRoute requiredRole="admin" userRole={userRole}>
                      <AdminPage />
                    </ProtectedRoute>
                  </Route>
                  <Route path="/instructor">
                    <ProtectedRoute requiredRole="instructor" userRole={userRole}>
                      <InstructorPage />
                    </ProtectedRoute>
                  </Route>
                  <Redirect to="/panel" />
                </Switch>
              </div>
            </div>
          </div>
        )}
      </Router>
    </ApiUrlContext.Provider>
  );
}

export default App;
